import { object } from 'prop-types';
import { Fragment } from 'react';

import * as Utils from 'atg/utils/Utils';
import { formatMoney } from 'shared/utils/money';
import { getText } from 'shared/utils/Text';

const BetItemInfo = ({ bet }) => {
  const stake = bet.getStake();
  const betKey = bet.getBetKey();
  const date = betKey.getDate();
  const track = bet.getTrack();

  let priceText, unreducedRows, reducedRows, betRowsText;

  if (stake) {
    const price = stake.getStake();
    const bongFee = stake.getBongFee();
    const priceSum = price?.getSum() || 0;
    const rawPrice = priceSum - bongFee;
    if (rawPrice > 0) {
      priceText = getText(
        'dialog-archive-price',
        formatMoney(rawPrice, price.getCurrency()),
      );
      if (bongFee > 0) {
        priceText += getText(
          'bong-fee',
          formatMoney(bongFee, price.getCurrency()),
        );
      }
    }

    unreducedRows = stake.getUnreducedRows();
    reducedRows = stake.getReducedRows();
    if (unreducedRows && reducedRows) {
      const reducedPercent =
        100 - Math.round((100 * reducedRows) / unreducedRows) || 0;
      betRowsText = getText(
        'dialog-archive-rows',
        reducedRows,
        unreducedRows,
        reducedPercent,
      );
    }
  }
  return (
    <Fragment>
      <h2>{bet.getName()}</h2>
      <div>{track && track.getName()}</div>
      <div>{betRowsText}</div>
      <div>{Utils.formatDate(date)}</div>
      <div>{priceText}</div>
      <div>
        {getText(
          'dialog-archive-modified',
          Utils.formatDateTime(bet.getModifiedTime()),
        )}
      </div>
      {bet.isShared() && (
        <div>
          {bet.isOwned()
            ? getText('dialog-archive-owned')
            : getText('dialog-archive-invited')}
        </div>
      )}
    </Fragment>
  );
};

BetItemInfo.propTypes = {
  bet: object.isRequired, // SavedBet
};

export default BetItemInfo;
